import propertySettingListStore from '@modules/property-setting/property-setting-list-store';
import propertySettingViewStore from '@modules/property-setting/property-setting-view-store';
import propertySettingImporterStore from '@modules/property-setting/property-setting-importer-store';
import propertySettingFormStore from '@modules/property-setting/property-setting-form-store';
import propertySettingDestroyStore from '@modules/property-setting/property-setting-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: propertySettingDestroyStore,
    form: propertySettingFormStore,
    list: propertySettingListStore,
    view: propertySettingViewStore,
    importer: propertySettingImporterStore,
  },
};
